import React, { useEffect } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { getModeNameByid } from "utils/AppUtils";

import { useTranslation } from "react-i18next";

function TotalSalesCard({ totalData }) {
  const {
    t,
  } = useTranslation();

  return (
    <Card className="strpied-tabled-with-hover">
      <Card.Header>
        <Row>
          <Col>
            <Card.Title as="h4">{`${totalData?.total?.name}`}</Card.Title>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="table-responsive p-0">
        <Table className="table-hover" style={{ tableLayout: "fixed" }}>
          <tbody>
            <tr>
              <td>{t("tables.headers.people")}</td>
              <td className="align-text-right">{totalData?.people}</td>
            </tr>
            {totalData?.modes?.map((row) => (
              <tr key={row.id}>
                <td>{getModeNameByid(row.id)}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
              </tr>
            ))}
            {totalData?.total?.paymentMethods.map((row) => (
              <tr key={row.id}>
                <td>{row.name}</td>
                <td className="align-text-right">{row.total.toFixed(2)}</td>
              </tr>
            ))}
            <tr>
              <td>{t("tables.headers.paid")}</td>
              <td className="align-text-right">{totalData?.total?.payed.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.discounts")}</td>
              <td className="align-text-right">{totalData?.total?.discount.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.cancellations")}</td>
              <td className="align-text-right">{totalData?.total?.cancelled.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.wastagePlural")}</td>
              <td className="align-text-right">{totalData?.total?.destroyed.toFixed(2)}</td>
            </tr>
            <tr>
              <td>{t("tables.headers.orders")}</td>
              <td className="align-text-right">{totalData?.total?.orders}</td>
            </tr>
            <tr>
              <td>TIPS</td>
              <td className="align-text-right">{totalData?.total?.tips.toFixed(2)}</td>
            </tr>
            <tr key="total">
              <td className="bold">{t("tables.headers.revenue")}</td>
              <td className="bold align-text-right">{totalData?.total?.turnover.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default TotalSalesCard;
